export const CONDITION_GOOD_VALUES: Record<string, string | string[]> = {
  windshield: 'no_damage',
  moon_roof: ['works_great', 'no_moon_roof'],
};

export const BOOLEAN_GOOD_VALUES: Record<string, boolean> = {
  smoked_in: false,
};

export const matchesGoodValue = (value: string, good: string | string[] | undefined): boolean => {
  if (good == null || !value) return false;
  return Array.isArray(good) ? good.includes(value) : value === good;
};

export const isConditionGoodValue = (questionId: string, value: string | undefined): boolean =>
  matchesGoodValue(value ?? '', CONDITION_GOOD_VALUES[questionId]);
